import React, {Component} from 'react';
import Translate from '../layout/Translate';
import cookie from 'react-cookie';

export default class CookiesPolicy extends Component {

  constructor (props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate () {
    let actions = this.props.actions;
    if (this.props.user.subscribe && this.props.user.subscribe.promise) {
      this.props.user.subscribe.promise.json().then(function (result) {
        actions.setSubscribeResult(result);
      });
    }
  }

  toggleModal () {
    this.props.actions.toggleCookiesPolicy();
    cookie.save('cookiesPolicyHide', true, {path: '/', maxAge: 60 * 60 * 24 * 365});
  }

  render () {
    return (
      <div className={"cookies-policy " + (this.props.open ? 'cookies-policy_active ' : '')}>
        <div className="cookies-policy__content">
          <div className="cookies-policy__text">
            <div className="cookies-policy__text_relative">
              <div className="cookies-policy__title">
                <Translate slug="cookies-policy__text1"/> <a href="/privacy" target="_blank"> <Translate slug="cookies-policy__text2"/></a>
              </div>
              <input
                type="button"
                className={"cookies-policy__submit"}
                value={this.props.translations["cookies-policy__submit"]}
                onClick={this.toggleModal.bind(this)}/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/popups/CookiesPolicy.js